import styled from 'styled-components';
import { Colors, mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const Content = styled.div `
  padding: 8px 20px 12px;
  background: ${Colors.GS100};
  display: grid;
  gap: 16px;
  align-items: center;
  width: 100%;
  grid-template-columns: 32px 1fr 32px;

  ${mediaQueries.tablet} {
    padding: 14px 32px 20px;
    grid-template-columns: 1fr fit-content(150px);
  }
`;
export const Title = styled.div `
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  text-align: center;

  ${mediaQueries.tablet} {
    font-size: 20px;
    line-height: 140%;
    text-align: left;
  }
`;
export const VisibilityWrapper = styled.div `
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
`;
export const Actions = styled.div `
  display: flex;
  gap: 12px;
  align-items: center;
`;
export const Button = styled.button `
  padding: 4px 14px;
  height: 32px;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  border: 1px solid ${Colors.GS1000};
  border-radius: 100px;
  display: flex;
  gap: 8px;
  align-items: center;
`;
